<template>
  <div
    id="form-validation-info"
    class="validation-info"
    :class="{
      'validation-info--error': error,
      'validation-info--valid': valid,
    }"
  >
    <fn-list
      unstyled
      horizontal
    >
      <li
        v-for="(rule, index) in rules"
        :id="'form-validation-info-list-item-' + index"
        :key="rule.title"
        class="vi-item"
        :class="{
          'vi-item--valid': rule.valid,
        }"
      >
        {{ rule.text }}
        <fn-icon
          v-if="rule.valid"
          icon="check-bold"
          size="xxs"
        />
      </li>
    </fn-list>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: Object,
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
    error: {
      type: Boolean,
    },
    valid: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -1px;
  padding: ($pad * 0.5) $pad;
  background-color: $color-general-background-neutral-default;
  border-radius: 0 0 map-get($border-radiuses, 'l') map-get($border-radiuses, 'l');
  border: 1px solid palette(grey, light);
  color: palette(grey);
  font-size: map-get($font-sizes, 's');

  .vi-item {
    position: relative;

    .icon {
      position: absolute;
      right: -$pad;
      top: -1px;
    }

    &.vi-item--valid {
      color: $color-brand-fnmz-green;
    }
  }

  &.validation-info--error {
    border-color: palette(red);
  }

  &.validation-info--valid {
    border-color: palette(green, light);
  }
}
</style>
